'use strict';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Theme Switcher
 * @author Jesse de Vries
 */
function Themeswitcher(options) {
    this.Init(options);
}
Themeswitcher.prototype = {
    /**
     * Constructor
     * @Param object options
     * @return void
     */
    // Initialize Object variables
    Init: function (options) { // Initialization
        // Default selectors
        this.options = Object.assign({
            themeswitchers: '.js-themeswitcher',
            themes: '.js-themeswitcher [data-theme]',
        }, options);
        // Initialize Prototype variables
        this.themeswitchers = document.querySelectorAll(this.options.themeswitchers);
        this.themes = this.options.themes;
        this.Start();
    },

    /**
     * Start
     * @return void
     */
    // Start
    Start: function() {

        const _this = this;

        const themeswitchers = this.themeswitchers;
        const themes = this.themes;

        const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
        let currentTheme = localStorage.getItem('theme');

        themeswitchers.forEach(function(themeswitcher) {
            let items = themeswitcher.querySelectorAll(themes);
            const control = themeswitcher.querySelector('.js-themeswitcher-control');


            items.forEach(function(item) {

                let theme = item.getAttribute('data-theme');

                function updateItemStates(currentTheme) {
                    items.forEach(function(item) {
                        if (item.getAttribute('data-theme') === currentTheme) {
                            item.setAttribute('aria-pressed', 'true');
                        } else {
                            item.removeAttribute('aria-pressed');
                        }
                    })
                }

                function setTheme(theme) {
                    document.documentElement.setAttribute('data-theme', theme);
                }

                if (currentTheme && currentTheme !== 'default') {
                    updateItemStates(currentTheme);
                    setTheme(currentTheme);
                    control.innerHTML = `<span class="icon-advanced icon-` + currentTheme + `-theme" aria-label="` + currentTheme + `"> theme</span>`
                } else {
                    if (prefersDarkScheme) {
                        updateItemStates('dark');
                        setTheme('dark');
                    }
                }

                item.addEventListener('click', function() {
                    if (theme !== 'default') {
                        currentTheme = document.documentElement.getAttribute('data-theme');
                        control.innerHTML = `<span class="icon-advanced icon-` + theme + `-theme" aria-label="` + theme + `"> theme</span>`
                        setTheme(theme);
                    } else {
                        if (prefersDarkScheme) {
                            setTheme('dark');
                        } else {
                            setTheme('light');
                        }
                        control.innerHTML = `<span class="icon-advanced icon-theme-adjust" aria-label="` + theme + `"> theme</span>`
                        currentTheme = 'default';
                    }
                    localStorage.setItem('theme', theme);
                    updateItemStates(theme);
                });

            });

        });
    },
}

export { Themeswitcher };
